/* eslint-disable no-nested-ternary */
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import PsTemporaryNotes from './PsTemporaryNotes';


/** PS 改廃案メモ一覧画面。 */
function PsTemporaryNotesPage() {

  // i18n 用。
  const {
    t,
    // i18n,
  } = useTranslation();

  // const defaultOptions = useDefaultOptions(i18n.language);

  // const location = useLocation();
  // const navigate = useNavigate();

  // console.log('location: ', location);

  // React Router の機能でパラメーターを取得。

  // PS バージョン ID: 対象となる PS とその配下の全 PS に紐づく PS 改廃案メモの一覧を表示する。
  const {
    psVersionId: psVersionIdParamString,
  } = useParams();

  // URL で指定したパラメーターが不適切であれば true。
  let isInvalidParam = false;

  /** URL で指定された PS バージョン ID。 */
  let psVersionIdParam: number | undefined;

  if (psVersionIdParamString) {
    psVersionIdParam = parseInt(psVersionIdParamString, 10);

    if (Number.isNaN(psVersionIdParam)) {
      psVersionIdParam = undefined;
      isInvalidParam = true;
    }
  }
  else {
    // psVersionId が指定されていなければならない。
    isInvalidParam = true;
  }

  const title = <title>
    {t('CMS-POC|PS改廃案メモ一覧')}
  </title>;

  if (isInvalidParam) {
    // URL が不適切。
    return (
      <>
        <Helmet>
          {title}
        </Helmet>
        <div id="main">
          {t('この URL は存在しません。')}
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        {title}
      </Helmet>
      <PsTemporaryNotes
        psVersionId={psVersionIdParam as number}
      />
    </>
  );
}

export default PsTemporaryNotesPage;
